export enum MapView {
    Ecology = 'Ecology',
    Team = 'Team',
    Activity = 'Activity',
    Member = 'Member',
};
